import { LocalizedAttributesValue } from 'src/generated/operations';

export function isRoomSensor<T extends LocalizedAttributesValue>(attribute?: T | null): boolean {
    return attribute?.raw?.includes('Room') ?? false;
}
